import { useWeb3React } from '@web3-react/core';
import { useCallback } from 'react';
import useWeb3 from '../useWeb3';
import Environment from '../../utils/Environment';
import { taskManagerContract } from '../../utils/contractHelpers';

const SubmitProofAgain = () => {
    
    const { account } = useWeb3React();
    const web3 = useWeb3();
    const tokenAddress = Environment.tastManager;
    const contract = taskManagerContract(tokenAddress, web3);

    const submitProofAgainHook = useCallback(async (taskId, proofHash) => {
        console.log(taskId, `ipfs://${proofHash}/`, "taskId, proofHash payload");
        // console.log(contract.methods.submitProofAgain, "proofHash payload function");

        try {
            var gasFunPrice;
            web3.eth.getGasPrice().then((result) => {
                var result2 = parseInt(result)
                gasFunPrice = result2.toString()
            })
            const gas = await contract.methods.submitProofAgain(taskId, `ipfs://${proofHash}/`).estimateGas({
                from: account
            });
            const details = await contract.methods.submitProofAgain(taskId, `ipfs://${proofHash}/`).send({
                from: account,
                gasPrice: gasFunPrice,
                gas,
            });
            return details;
        } catch (error) {
            console.log(error, 'error');

            throw error;
        }
    }, [contract, account]);
    return { submitProofAgainHook }
}

export default SubmitProofAgain
